import { useUpdatePatient as useUpdatePatientShared } from '@avanta/shared/hooks/useUpdatePatient';
import { type Patient } from '@avanta/shared/types/patients';
import { type User } from '@avanta/shared/types/users';
import { type UseMutationResult } from '@tanstack/react-query';
import { useUserStore } from 'stores/user';

export const useUpdatePatient = (showToast = true): UseMutationResult<void, Error, Patient> => {
  const hook = useUpdatePatientShared(showToast);
  const setUser = useUserStore(state => state.setUser);

  if (hook.isSuccess && hook.variables) {
    setUser(hook.variables as User);
  }
  return hook;
};
